import React from "react";

interface Props {
  settings: any;
  setSettings: any;
}
const AppointmentPrices = (props: Props) => {
  const {} = props;
  return <></>;
};

export default AppointmentPrices;
